import { Injectable } from '@angular/core';

import { Observable, Observer } from 'rxjs';
import { CourrierEditionFormComponent } from '../private/COURRIER-S/courrier-edition-form/courrier-edition-form.component';
import { DialogService } from 'primeng/dynamicdialog';
import { GuardConfirmModalComponent } from 'src/app/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { DataService } from '../shared/services/data.service';
import { MailsLockUnlockService } from '../shared/services/mails-lock-unlock.service';

@Injectable({
  providedIn: 'root',
})
export class CourrierDeactivateGuard {
  public canLeaveEditor: boolean;
  constructor(
    public dialogService: DialogService,
    private dataService: DataService,
    private mailsLockUnlockService: MailsLockUnlockService
  ) {
    this.dataService.canLeaveEditorInfo.subscribe({
      next: (canLeaveEditor) => {
        this.canLeaveEditor = canLeaveEditor;
      },
    });
  }

  canDeactivate(component: CourrierEditionFormComponent) {
    if (component && this.canLeaveEditor && ((component.form && !component.form.dirty) || component.isFormSubmit === true)) {
      return new Observable((observer: Observer<boolean>) => {
        if (component.mailId) {
          const data = {
            courrierIds: [component.mailId],
          };
          this.mailsLockUnlockService.unLock('Write', data).subscribe({
            next: () => {
              observer.next(true);
              observer.complete();
            },
            error: (err) => {
              console.error(err);
              observer.next(false);
              observer.complete();
            },
          });
        } else {
          observer.next(true);
          observer.complete();
        }
      });
    } else {
      return new Observable((observer: Observer<boolean>) => {
        const ref = this.dialogService.open(GuardConfirmModalComponent, {
          header: 'Confirmation',
          styleClass: 'super-compos-modal-content ',
          dismissableMask: false,
          width: '30em',
          data: {
            message: 'Attention, si vous continuez, vos données ne seront pas sauvegardées. Êtes vous sûr de vouloir quitter ?',
          },
        });
        ref.onClose.subscribe({
          next: (value) => {
            if (value) {
              if (value === true) {
                if (component.mailId) {
                  // observer.next(true);
                  const data = {
                    courrierIds: [component.mailId],
                  };
                  this.mailsLockUnlockService.unLock('Write', data).subscribe({
                    next: () => {
                      observer.next(true);
                      observer.complete();
                    },
                    error: (err) => {
                      console.error(err);
                      observer.next(false);
                      observer.complete();
                    },
                  });
                } else {
                  observer.next(true);
                  observer.complete();
                }
              } else {
                observer.next(false);
                observer.complete();
              }
            }
          },
        });
      });
    }
  }
}
